export default "__VITE_ASSET__bnBSJr9m__"